import download_component from '#BASE/components/downLoad/DownLoadCenterAndAFK';

export default {
    mixins: [download_component],
    data: function () {
        return {
            // 状态控制
            selectedTab: 'android', // 默认选中Android

            // 二维码配置
            QrcodeOptions: {
                width: 170,
                margin: 1,
            },
        };
    },
    methods: {
        // 重写父类InitCallback方法，增加自定义逻辑
        InitCallback() {
            // 有安卓或ios下載連結設定預設
            if (this.androidUrl || this.iosUrl) {
                this.setDefaultTab();
            }
            
            // 通知父组件数据已经加载完成
            this.$emit('ready');
            
        },

        // 设置默认标签页
        setDefaultTab() {
            if (this.androidUrl) {
                this.selectedTab = 'android';
            } else if (this.iosUrl) {
                this.selectedTab = 'ios';
            }
        },

        // 切换标签页
        switchTab(tab) {
            this.selectedTab = tab;
        },

        // 根据平台设置选中的标签页
        setSelectedPlatform(platform) {
            if (platform === 'ios' && this.iosUrl) {
                this.selectedTab = 'ios';
            } else if (platform === 'android' && this.androidUrl) {
                this.selectedTab = 'android';
            } else {
                this.setDefaultTab();
            }
        },

        // 关闭下载弹窗
        closeDownload() {
            this.AppDownloadShow = false;
        },

        // 重写showAppDownload方法，添加平台选择功能
        showAppDownload(platform = 'android') {
            this.setSelectedPlatform(platform);
            // 调用父类属性
            this.AppDownloadShow = true;
        },

        // 打开挂机软件下载
        showAFKDownload() {
            if (this.AFKPcUrl) {
                window.open(this.AFKPcUrl, '_blank');
            } else {
                console.error('挂机软件下载链接不可用');
            }
        },

        openAppDownload(platform = 'android') {
            this.showAppDownload(platform);
        },

        openAFKDownload() {
            this.showAFKDownload();
        },
    },
    computed: {
        // 计算当前二维码URL
        currentQrUrl() {
            if (this.selectedTab === 'ios') {
                return this.iosUrl || '';
            } else {
                return this.androidUrl || '';
            }
        },
    },
};
